<template lang="pug">
.bet-slip.parlay
  .bet-slip-wrapper(:class="{ live: isLiveMarket }")
    .stake-info-wrapper
      .bet-type
        .head-wrapper
          | {{ match.mmo || match.bet_type_share == "PARLAYMMO" ? $t("ui.mmo_parlay") : $t("m.BT_PARLAY") }}
        template(v-if="!status")
          .bet-status.win(v-if="parseFloat(match.winlose) > 0")
            span {{ $t("ui.win") }}
          .bet-status.draw(v-else-if="parseFloat(match.winlose) == 0")
            span {{ $t("ui.draw") }}
          .bet-status.lose(v-else-if="parseFloat(match.winlose) < 0")
            span {{ $t("ui.lose") }}
        template(v-else)
          .bet-status(:class="match.bet_status.toLowerCase()")
            span {{ $t("ui." + match.bet_status.toLowerCase()) }}
      .stake-info
        .betslip-match
          template(v-if="['esports2'].includes(filterMenu)")
            .selector-odd
              span.text {{ $t("m.BT_PARLAY") }}
              .bet-type-odds
                .odds
                  span {{ match.member_odds }}
          template(v-else)
            .selector-odd
              span.text {{ betType(match) }}
              .bet-type-odds
                span.bet-type-text(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(match.bet_type)") {{ ballDisplay(match) }}
                .odds(:class="getNumberClass(match.odds_display)") {{ status == '' ? match.odds_display_bet : match.odds_display }}
      .payout-wrapper
        .left
          | {{ $t("ui.stake") }}: 
          span.amount(v-if="['esports2'].includes(filterMenu)") {{ $numeral(match.bet_amount).format("0,0.[00]") }}
          span.amount(v-else) {{ $numeral(match.bet_member).format("0,0.[00]") }}
        .right(v-if="!['Running', 'Waiting', 'Rejected'].includes(status)")
          template(v-if="match.winlose")
            template(v-if="match.payout || match.payout == 0")
              | {{ parseFloat(match.winlose) < 0 ? $t("ui.lose") : parseFloat(match.winlose) == 0 ? $t("ui.draw") : $t("ui.win") }}:
            template(v-else)
              | {{ $t("ui.payout") }}:
            span.amount(:class="match.winlose != 0 ? match.winlose > 0 ? 'win-amount' : 'lose-amount' : ''") {{ $numeral(match.winlose).format("0,0.00") }}
      .parlay-inner-layer.collapse(:id="'statement-child-' + this.uniqueID" :data-bs-parent="'#statement-' + index")
        .bet-slip-inner(v-for="parlay in parlayItems" :class="{ live: isLiveSelection(parlay) }")
          //- small {{ parlay }}
          .stake-info-wrapper
            .bet-type
              template(v-if="['esports2'].includes(filterMenu)")
                .bet-status(:class="parlay.result_status == 'WIN' ? 'won' : 'lose'")
                  span {{ parlay.result_status }}
                .bet-league
                  img.icon.mr-1(:src="'/images/icon-sport-svg/20.svg'")
                  | {{ $t("ui.esports2") }}
                .stake-info
                  .betslip-match
                    .team-involved(v-if="parlay.game_type_name")
                      span.mr-1 {{ parlay.game_type_name }}
                      span(v-if="parlay.game_market_name") ({{ parlay.game_market_name }})
                  .selector-odd
                    .bet-type-odds
                      span.text-danger.text-uppercase.mr-1 {{ parlay.bet_selection }}
                      span.mr-1 {{ parlay.bet_type_name }}
                      span.mr-1 @ {{ parlay.member_odds }}
              template(v-else)
                .head-wrapper
                  ThemeImage.icon(:src="'/images/light/sport/blue/' + getSportsImage(parlay) + '.svg'")
                  | {{ sports[parlay.sports_type] }} - {{ betType(parlay) }}
                template(v-if="match['criteria2'] || match['bet_type_share'] == 'PARLAYMMO'")
                  template(v-if="$helpers.mmoParlayResult(parlay) == $t('ui.lose') || $helpers.mmoParlayResult(parlay) == $t('ui.lose_half')")
                    .bet-status.lose
                      span {{ $helpers.mmoParlayResult(parlay) }}
                  template(v-else-if="[$t('ui.draw_cancel'),$t('ui.cancel'),$t('ui.void'),$t('ui.abandoned')].includes($helpers.showWinStatus(parlay))")
                    .bet-status.draw
                      span {{ $helpers.mmoParlayResult(parlay) }}
                  template(v-else-if="$helpers.mmoParlayResult(parlay) == $t('ui.win') || $helpers.mmoParlayResult(parlay) == $t('ui.win_half')")
                    .bet-status.won
                      span {{ $helpers.mmoParlayResult(parlay) }}
                  template(v-else)
                    .bet-status.blank
                      span {{ $helpers.mmoParlayResult(parlay) }}
                template(v-else)
                  template(v-if="$helpers.showWinStatus(parlay) == $t('ui.lose') || $helpers.showWinStatus(parlay) == $t('ui.lose_half')")
                    .bet-status.lose
                      span {{ $helpers.showWinStatus(parlay) }}
                  template(v-else-if="[$t('ui.draw_cancel'),$t('ui.cancel'),$t('ui.void'),$t('ui.abandoned')].includes($helpers.showWinStatus(parlay))")
                    .bet-status.draw
                      span {{ $helpers.showWinStatus(parlay) }}
                  template(v-else-if="$helpers.showWinStatus(parlay) == $t('ui.win') || $helpers.showWinStatus(parlay) == $t('ui.win_half')")
                    .bet-status.won
                      span {{ $helpers.showWinStatus(parlay) }}
                  template(v-else)
                    .bet-status.blank
                      span {{ $helpers.showWinStatus(parlay) }}              
            .stake-info
              .betslip-match
                .team-involved
                  span.d-block {{ getName(parlay, 0) }}
                  span.score(v-if="parlay.market_type == 3 && parlay.home_running_score != null") {{ parlay.home_running_score + "-" + parlay.away_running_score }}
                  span.d-block(:class="parlay.home_giving == 1 && isBallDisplay(parlay) ? 'team2' : 'team1'") {{ getName(parlay, 1) }}
                  span.d-block(:class="parlay.home_giving == 0 && isBallDisplay(parlay) ? 'team2' : 'team1'" ) {{ getName(parlay, 2) }}
              .selector-odd.d-flex.justify-content-between.mb-1
                span.text
                  span.market-type {{ parlay.bet_type }}
                  span.team-name(:class="isBallDisplay(parlay) == false ? '' : ((parlay.home_giving == 0 && parlay.home_away == 2) ? 'team2' : (parlay.home_giving == 1 && parlay.home_away == 1) ? 'team2' : 'team1')") {{ betDisplay(parlay) }}
                .bet-type-odds
                  //- small {{ parlay }}
                  template(v-if="parlay.criteria2")
                    template(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(parlay.bet_type)")
                      span(:class="{ 'negetive' : showOdds(parlay.bet_type.toUpperCase(), parlay.home_away, parlay.home_giving, parlay.ball_display) < 0 }") {{ showOdds(parlay.bet_type.toUpperCase(), parlay.home_away, parlay.home_giving, parlay.ball_display) }}
                      template(v-if="parlay.criteria2 < 0")
                        span.negetive ({{ $numeral(parlay.criteria2).format("0") }})
                      template(v-else)
                        span ({{ $numeral(parlay.criteria2).format("0") }})
                  template(v-else)
                    span.bet-type-text(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(parlay.bet_type)") {{ ballDisplay(parlay) }}
                    .odds(:class="getNumberClass(parlay.odds_display)") {{ parlay.odds_display }}
          .bet-details-important.text-center
            template(v-if="['esports2'].includes(filterMenu)")
              .bet-details-league(v-if="parlay.event_name") {{ parlay.event_name }}
              .bet-details-result(v-if="parlay.competition_name") {{ parlay.competition_name }}
              .bet-details-result {{ $t("ui.result") }}:
                span.text-uppercase.ml-1 {{ parlay.result }}
            template(v-else)
              .bet-details-league {{ getName(parlay, 0) }}
              .bet-details-result(v-if="parlay.home_score != null") {{ $t("ui.result") }}: {{ parlay.home_score + "-" + parlay.away_score }}
        .bet-details
          .bet-details-row
            .left {{ $t("ui.bet") }}: {{ match.created_on ? $dayjs(match.created_on).format("MM/DD/YYYY hh:mm:ss A") : $dayjs(match.bet_time).format("MM/DD/YYYY hh:mm:ss A")}}
          .bet-details-row(v-if="['sportsbook','adjustment', 'void', 'livecasino', 'esports2'].includes(filterMenu)")
            template(v-if="['esports2'].includes(filterMenu)")
              .left {{ $t("ui.comm") }}: {{ $numeral(match.comm).format("0,0.00") }}
              .right.text-uppercase(v-if="match.member_odds_style") {{ $t("ui.odds") }}: {{ match.member_odds_style }}
            template(v-else)
              .left {{ $t("ui.comm") }}: {{ $numeral(match.member_commission).format("0,0.[00]") }}
              template(v-if="match['criteria2'] || match['bet_type_share'] == 'PARLAYMMO'")
                .right(v-if="['sportsbook','adjustment','void'].includes(filterMenu)") {{ $t("ui.odds") }}: {{ $t(odds[5]) }}
              template(v-else)
                .right(v-if="['sportsbook','adjustment','void'].includes(filterMenu)") {{ $t("ui.odds") }}: {{ $tc(odds[match.odds_type]) }}
          .bet-details-row
            .left ID: {{ ['sportsbook','adjustment','void'].includes(filterMenu) ? this.uniqueID : match.bet_id }}
            .right(v-if="['sportsbook','adjustment','void'].includes(filterMenu)") IP: {{ match.ip }}
      .btn-more-detail(:id="'statement-child-btn-' + this.uniqueID" data-bs-toggle='collapse' :data-bs-target="'#statement-child-' + this.uniqueID" :aria-expanded="detailsExpanded" :aria-controls="'statement-child-' + this.uniqueID") {{ detailButtonText }}

</template>

<script>
import config from "@/config";
import service from "@/library/_xhr-statement";
import xhr from "@/library/_xhr-betlist.js";
import naming from "@/library/_name";
import betSlipDetailToggle from "@/mixins/betSlipDetailToggle";

export default {
  mixins: [betSlipDetailToggle],
  props: {
    index: {
      type: Number
    },
    match: {
      type: [Object, Array]
    },
    filterMenu: {
      type: String,
      default: "sportsbook"
    },
    status: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      parlayItems: [],
      leagueList: [],
      matchList: []
    }
  },
  computed: {
    isLiveMarket() {
      if (this.isLiveSelection(this.match)) return true;
      return this.parlayItems.some(item => this.isLiveSelection(item));
    },
    sports() {
      return this.$store.state.layout.sports;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    odds() {
      return config.oddsTypeLocale;
    },
    language() {
      return this.$store.getters.language;
    },
    uniqueID() {
      if(this.match) {
        return this.match.result_id || this.match.bet_id
      }
    }
  },
  methods: {
    isLiveSelection(item) {
      if (!item) return false;
      if (item.market_type == 3) return true;
      const live = this.$store.state.cache.live;
      return item.match_id != null && live != null && live[item.match_id] == 3;
    },
    isBallDisplay(parlay) {
      var result = naming.ballDisplay2(parlay.ball_display, parlay.home_giving, parlay.home_away, parlay.bet_type, this);
      if (["HDP", "HDPH"].includes(parlay.bet_type)) {
        return result != null && result != "0";
      } else {
        return false;
      }
    },
    showOdds(bet_type, home_away, giving, odds) {
      return naming.ballDisplayMMO1(odds, giving, home_away, bet_type, this);
    },
    getName: function(match, mode) {
      let name = ""
      if(mode == 0) {
        if(['running', 'waiting', 'rejected'].includes(this.status)) {
          name = (match["name_" + this.language]) ? match["name_" + this.language] : match["league_name"];
        } else {
          this.leagueList.forEach(x => {
            if(x.league_id == match.league_id) {
              name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
            }
          })
        }
      } else {
        if(['running', 'waiting', 'rejected'].includes(this.status)) {
          if (mode == 1) {
            name = (match["home_name_" + this.language]) ? match["home_name_" + this.language] : match["home_team_name"];
          } else {
            name = (match["away_name_" + this.language]) ? match["away_name_" + this.language] : match["away_team_name"];
          }
        } else {
          this.matchList.forEach(y => {
            if(y.match_id == match.match_id) {
              if (mode == 1) {
                name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
              } else {
                name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
              }
            }
          })
        }
      }
      return name;
    },
    onDetailExpanded() {
      this.getParlayDetails(this.uniqueID);
    },
    getSportsImage(e) {
      if(e.sports_type == -1 || e.sports_type == 0) {
        e.sports_type = 1
      }
      return config.getSportsImage(e.sports_type);
    },
    betType(e) {
      var label = ""
      if(e.bet_type == 'PARLAY') {
        // label = e.total_match > 0 ? this.$t("ui.folds_" + e.total_match) : e.mmo || e.bet_type_share == "PARLAYMMO" ? this.$t("ui.mmo_parlay") : this.$t("m.BT_" + e.bet_type);
        label = e.mmo || e.bet_type_share == "PARLAYMMO" ? this.$t("ui.mmo_parlay") : e.total_match > 0 ? this.$t("ui.folds_" + e.total_match) : this.$t("m.BT_" + e.bet_type);
      } else {
        label = this.$t("m.BS_" + e.bet_type);
      }
      return label;
    },
    betDisplay(e) {
      return naming.betDisplay(e, this);
    },
    ballDisplay(e) {
      // return naming.ballDisplay(e, this);
      if(e.ball_display) {
        return naming.ballDisplay2(e.ball_display, e.home_giving, e.home_away, e.bet_type, this);
      } else {
        return naming.ballDisplay1(e, this);
      }
    },
    getNumberClass(e) {
      return parseFloat(e) >= 0 ? "" : "negetive";
    },
    getParlayDetails(result_id) {
      if (this.loading == true) return;

      if (this.isLoggedIn) {
        this.loading = true;
        this.parlayItems = [];

        var json = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          bet_id: result_id
        };

        switch (this.status) {
          case "running":
            xhr.getParlayAcceptDetails(json).then(
              res => {
                this.loading = false;
                if (res) {
                  if (res.success == true) {
                    this.parlayItems = res.data;
                  } else {
                    this.$helpers.handleFeedback(res.status, res.source);
                  }
                }
              },
              err => {
                this.loading = false;
                this.$helpers.handleFeedback(err.status, err.source);
              }
            );
            break;
          case "waiting":
            xhr.getParlayPendingDetails(json).then(
              res => {
                this.loading = false;
                if (res) {
                  if (res.success == true) {
                    this.parlayItems = res.data;
                  } else {
                    this.$helpers.handleFeedback(res.status, res.source);
                  }
                }
              },
              err => {
                this.loading = false;
                this.$helpers.handleFeedback(err.status, err.source);
              }
            );
            break;
          case "rejected":
            xhr.getParlayRejectDetails(json).then(
              res => {
                this.loading = false;
                if (res) {
                  if (res.success == true) {
                    this.parlayItems = res.data;
                  } else {
                    this.$helpers.handleFeedback(res.status, res.source);
                  }
                }
              },
              err => {
                this.loading = false;
                this.$helpers.handleFeedback(err.status, err.source);
              }
            );
            break;
          default:
            service.getParlayDetails(json).then(
              res => {
                this.loading = false;
                if (res) {
                  if (res.success == true) {
                    this.parlayItems = res.data;
                    this.matchList = res.names["Table"];
                    this.leagueList = res.names["Table1"];
                  } else {
                    this.$helpers.handleFeedback(res.status, res.source);
                  }
                }
              },
              err => {
                this.loading = false;
                this.$helpers.handleFeedback(err.status, err.source);
              }
            )
            break;
        }
      }
    }
  }
}
</script>